module.exports = __webpack_public_path__ + "static/img/Vector.30f80822.svg";